
import { css } from 'lit';
export default css`
.search__overlay {
  background-color: transparent;
}
  .search__overlay {
    z-index: -1;
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .search__overlay--show {
      display: block;
    }
  .search__input {
  width: 100%;
}
  .search__input {
  border-radius: 9999px;
}
  .search__input {
  border-width: 1px;
}
  .search__input {
  border-right-width: 0px;
}
  .search__input {
  border-style: solid;
}
  .search__input {
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}
  .search__input {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
  .search__input {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
  .search__input {
  padding-left: 2rem;
}
  .search__input {
  padding-right: 4rem;
}
  .search__input {
  font-size: 1.125rem;
}
  .search__input {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
  @media (min-width: 1024px) {
  .search__input {
    width: 100%;
  }
}
  @media (min-width: 1024px) {
  .search__input {
    padding-right: 4.5rem;
  }
}
  @media (min-width: 1024px) {
  .search__input {
    font-size: 1.375rem;
  }
}
  .search__input::-moz-placeholder {
  font-style: italic;
}
  .search__input:-ms-input-placeholder {
  font-style: italic;
}
  .search__input::placeholder {
  font-style: italic;
}
  .search__input::-moz-placeholder {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}
  .search__input:-ms-input-placeholder {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}
  .search__input::placeholder {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}
  .search__input:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
  .search__input-clear {
    cursor: pointer;
    width: 20px;
    height: 20px;
    position: absolute;
    bottom: 0;
    top: 0;
    margin: auto;
    right: 90px;
    display: none;
  }
  .search__input-clear--show {
      display: block;
    }
  .search__input-clear hf-icon {
      fill: #6b1f99;
    }
  .search__input-clear hf-icon:hover {
  fill: currentColor;
}
  .search__input-clear hf-icon:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}
  .search__submit {
  margin-left: -4rem;
}
  .search__submit {
  width: 4rem;
}
  .search__submit {
  border-radius: 9999px;
}
  .search__submit {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
  .search__submit {
  border-width: 1px;
}
  .search__submit {
  border-left-width: 0px;
}
  .search__submit {
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}
  .search__submit {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
  .search__submit {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
  .search__submit {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
  @media (min-width: 1024px) {
  .search__submit {
    margin-left: -4.5rem;
  }
}
  @media (min-width: 1024px) {
  .search__submit {
    width: 4.5rem;
  }
}
  @media (min-width: 1024px) {
  .search__submit {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
  .search__submit:hover, .search__submit:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}
  .search__submit:hover, .search__submit:focus {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
  .search__submit:hover, .search__submit:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
  .search__icon {
    /* ie11 fix */
  }
  .search__icon {
  height: 1.25rem;
}
  .search__icon {
  width: 1.25rem;
}
  .search__container {
  position: relative;
}
  .search__container {
  display: inline-flex;
}
  .search__container {
  width: 100%;
}
  .search__container {
    z-index: 301;
  }
  .search__container .search__input::-moz-placeholder {
        color: #737373;
        font-weight: lighter;
        font-style: italic;
      }
  .search__container .search__input:-ms-input-placeholder {
        color: #737373;
        font-weight: lighter;
        font-style: italic;
      }
  .search__container .search__input::placeholder {
        color: #737373;
        font-weight: lighter;
        font-style: italic;
      }
  .search__container:focus-within:not(.search__page-header) {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
  /* stylelint-disable-next-line */
  .search__container:focus-within:not(.search__page-header) .search__input {
  --tw-shadow: 0 0 20px 0 rgba(107, 31, 153, 0.6);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  .search__container:focus-within:not(.search__page-header) .search__input {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
  .search__container:focus-within:not(.search__page-header) .search__input::-moz-placeholder {
  --tw-text-opacity: 1;
  color: rgba(117, 118, 119, var(--tw-text-opacity));
}
  .search__container:focus-within:not(.search__page-header) .search__input:-ms-input-placeholder {
  --tw-text-opacity: 1;
  color: rgba(117, 118, 119, var(--tw-text-opacity));
}
  .search__container:focus-within:not(.search__page-header) .search__input::placeholder {
  --tw-text-opacity: 1;
  color: rgba(117, 118, 119, var(--tw-text-opacity));
}
  .search__page-header {
  position: relative;
}
  .search__page-header {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
  @media (min-width: 768px) {
  .search__page-header {
    background-color: transparent;
  }
}
  /* stylelint-disable-next-line */
  .search__page-header .search__input {
  border-radius: 0px;
}
  .search__page-header .search__input {
  border-style: none;
}
  .search__page-header .search__input {
  padding: 1rem;
}
  .search__page-header .search__input {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
  .search__page-header .search__input {
      width: calc(100% - 4rem - 0.5rem);
    }
  .search__page-header .search__submit {
  margin-left: 1rem;
}
  .search__page-header .search__submit {
  display: flex;
}
  .search__page-header .search__submit {
  width: auto;
}
  .search__page-header .search__submit {
  flex-direction: row;
}
  .search__page-header .search__submit {
  align-items: center;
}
  .search__page-header .search__submit {
  justify-content: center;
}
  .search__page-header .search__submit {
  border-radius: 0px;
}
  .search__page-header .search__submit {
  border-width: 1px;
}
  .search__page-header .search__submit {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}
  .search__page-header .search__submit {
  background-color: transparent;
}
  .search__page-header .search__submit {
  font-size: 1.25rem;
}
  .search__page-header .search__submit {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
  .search__page-header .search__submit {
      border-style: inset;
    }
  .search__page-header .search__submit:hover, .search__page-header .search__submit:focus {
  border-width: 1px;
}
  .search__page-header .search__submit:hover, .search__page-header .search__submit:focus {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}
  .search__page-header .search__submit:hover, .search__page-header .search__submit:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}
  .search__page-header .search__submit:hover, .search__page-header .search__submit:focus {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
  .search__page-header .search__submit:hover, .search__page-header .search__submit:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
  @media (min-width: 768px) {
  .search__page-header .search__submit {
    --tw-border-opacity: 1;
    border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  }
}
  @media (min-width: 768px) {
  .search__page-header .search__submit {
    --tw-bg-opacity: 1;
    background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
  }
}
  @media (min-width: 768px) {
  .search__page-header .search__submit {
    fill: currentColor;
  }
}
  @media (min-width: 768px) {
  .search__page-header .search__submit {
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, var(--tw-text-opacity));
  }
}
  .search__page-header .search__icon {
  height: 1.25rem;
}
  .search__page-header .search__icon {
  width: 1.25rem;
}
  @media (min-width: 768px) {
  .search__page-header .search__icon {
    margin-left: 0.5rem;
  }
}
  .search__text {
    display: none;
  }
  .search__header {
  justify-content: space-between;
}
  .search__header .search__input, .search__header .search__submit {
  border-radius: 0px;
}
  .search__header .search__input, .search__header .search__submit {
  border-width: 0px;
}
  .search__header .search__input, .search__header .search__submit {
  border-bottom-width: 1px;
}
  .search__header .search__input, .search__header .search__submit {
  border-style: solid;
}
  .search__header .search__input, .search__header .search__submit {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}
  .search__header .search__input, .search__header .search__submit {
  padding: 0px;
}
  .search__header .search__input::-moz-placeholder, .search__header .search__submit::-moz-placeholder {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
  .search__header .search__input:-ms-input-placeholder, .search__header .search__submit:-ms-input-placeholder {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
  .search__header .search__input::placeholder, .search__header .search__submit::placeholder {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
  .search__header .search__input::-moz-placeholder, .search__header .search__submit::-moz-placeholder {
  font-size: 1.125rem;
}
  .search__header .search__input:-ms-input-placeholder, .search__header .search__submit:-ms-input-placeholder {
  font-size: 1.125rem;
}
  .search__header .search__input::placeholder, .search__header .search__submit::placeholder {
  font-size: 1.125rem;
}
  .search__header .search__input::-moz-placeholder, .search__header .search__submit::-moz-placeholder {
  font-weight: 600;
}
  .search__header .search__input:-ms-input-placeholder, .search__header .search__submit:-ms-input-placeholder {
  font-weight: 600;
}
  .search__header .search__input::placeholder, .search__header .search__submit::placeholder {
  font-weight: 600;
}
  .search__header .search__input::-moz-placeholder, .search__header .search__submit::-moz-placeholder {
  font-style: normal;
}
  .search__header .search__input:-ms-input-placeholder, .search__header .search__submit:-ms-input-placeholder {
  font-style: normal;
}
  .search__header .search__input::placeholder, .search__header .search__submit::placeholder {
  font-style: normal;
}
  .search__header .search__input::-moz-placeholder, .search__header .search__submit::-moz-placeholder {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
  .search__header .search__input:-ms-input-placeholder, .search__header .search__submit:-ms-input-placeholder {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
  .search__header .search__input::placeholder, .search__header .search__submit::placeholder {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
  .search__header .search__submit {
  width: 2.5rem;
}
  .search__container--hp .search__input, .search__container--hp .search__submit {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}
  .search__container--hp .search__input, .search__container--hp .search__submit {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}
  .search__container--hp .search__input, .search__container--hp .search__submit {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
  .search__container--hp .search__input::-moz-placeholder, .search__container--hp .search__submit::-moz-placeholder {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
  .search__container--hp .search__input:-ms-input-placeholder, .search__container--hp .search__submit:-ms-input-placeholder {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
  .search__container--hp .search__input::placeholder, .search__container--hp .search__submit::placeholder {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
  .search__container--hp .search__submit {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}
  .search__container--hp .search__submit {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}
  .search__container--hp .search__submit {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
  .search__container--hp .search__submit:hover, .search__container--hp .search__submit:focus {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}
  .search__container--hp .search__submit:hover, .search__container--hp .search__submit:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
  .search__container--hp .search__submit:hover, .search__container--hp .search__submit:focus {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
  @media (min-width: 768px) {
  .search__container--hp .search__submit {
    --tw-border-opacity: 1;
    border-color: rgba(107, 31, 153, var(--tw-border-opacity));
  }
}
  @media (min-width: 768px) {
  .search__container--hp .search__submit {
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, var(--tw-text-opacity));
  }
}
  .search__container--hp .search__input-clear hf-icon {
        fill: #fff;
      }
  .search__container--hp .search__input-clear hf-icon:hover {
  --tw-text-opacity: 1;
  color: rgba(254, 254, 254, var(--tw-text-opacity));
}
  .search__offleft {
    position: absolute;
    left: -9999px;
  }

::slotted(*) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

@media (min-width: 768px) {
  ::slotted(*) {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
}
`;